import {
  formatDateToMonthDayYear,
  fullFormatNumbers,
  RevCard,
} from "@revmatics/catalyst";
import { CampaignByIdItemDataType } from "../../../../../../../../stores/types/campaignsTypes.tsx";
import { campaignKPIOptions } from "../../../../../../../../pages/campaigns/data/campaignData.ts";
import { RecommendationItem } from "../recommendations/RecommendationItem.tsx";

type Props = {
  campaignById: CampaignByIdItemDataType;
};
export const CampaignDetailsView = ({ campaignById }: Props) => {
  return (
    <RevCard title="General" paddingTitle="px-6 py-4" className="space-y-6">
      <div className="space-y-2">
        <p className="typography-body-bold-sm text-monochrome-900">
          Campaign Name
        </p>
        <p className="typography-body-sm text-monochrome-900">
          {campaignById.name}
        </p>
      </div>
      <div className="space-y-2">
        <p className="typography-body-bold-sm text-monochrome-900">
          Strategic goals and key performance indicators (KPIs)
        </p>
        <p className="typography-body-sm text-monochrome-900">
          {campaignById.kpi
            ? `${campaignKPIOptions.find((item) => item.value === campaignById.kpi)?.label} ${campaignById.kpi_value ? `- ${campaignById.kpi_value}X` : ""}`
            : "—"}
        </p>
      </div>
      <div className="space-y-2">
        <h6>Timeline</h6>
        <p className="typography-body-sm text-monochrome-900">
          From{" "}
          {campaignById.time_frame.start
            ? formatDateToMonthDayYear(campaignById.time_frame.start)
            : "—"}{" "}
          to{" "}
          {campaignById.time_frame.end
            ? formatDateToMonthDayYear(campaignById.time_frame.end)
            : "—"}
        </p>
      </div>
      <div className="space-y-2">
        <h6>Budget</h6>
        <p className="typography-body-sm text-monochrome-900">
          ${fullFormatNumbers({ value: campaignById.total_budget }) || "—"}
        </p>
      </div>
      {campaignById.recommendations.length > 0 && (
        <div className="space-y-2">
          <h6>User Recommendations</h6>
          <div className="space-y-1">
            {campaignById.recommendations.map((item) => (
              <RecommendationItem
                data={item}
                key={`recommendations-campaign-${item.label}-${item.icon_class}-${item.type}`}
              />
            ))}
          </div>
        </div>
      )}
    </RevCard>
  );
};
